import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import Reveal from "@/components/Reveal";

export default function NotFound() {
  return (
    <main data-testid="not-found-page">
      <section className="page-section not-found-page">
        <div className="shell not-found-shell">
          <Reveal>
            <span className="section-kicker">404 / The page is not here</span>
            <h1 className="not-found-title">The thread ends here.</h1>
            <p className="not-found-copy">This address does not lead to a published page. Return to the home page and continue through the current work.</p>
            <Link to="/" className="button-primary" data-testid="not-found-home-link"><ArrowLeft size={15} /> Back to Home</Link>
          </Reveal>
        </div>
      </section>
    </main>
  );
}
